import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    lng: 'en-US',
    load: 'currentOnly',
    supportedLngs: ['en-US', 'en-CA', 'fr-CA', 'fr-FR', 'nl-NL', 'pt-BR'],
    debug: true,
    crossDomain: false,
    backend: {
      backends: [
        LocalStorageBackend,
        HttpBackend
      ],
      backendOptions: [
        {
          prefix: 'i18next_res_',
          expirationTime: 60 * 60 * 1000,
          store: window.sessionStorage
        },
        {
          loadPath: process.env.REACT_APP_SHELL_URL + '/locales/{{lng}}/{{ns}}.json'
        }
      ]
    },
    interpolation: { escapeValue: false }
  }).then(() => {
    console.log('set language as: ', i18n.language);
  });

i18n.on('languageChanged', (lng) => {
  console.log('language', lng);
});

// Make i18n available globally for MFEs
window.__SHARED_I18N__ = i18n;

export default i18n;